
export default {
    name: 'ListDetailTable',
    props: {
        newsItems: Array,
        detailPath: {
            type: String,
            default: 'Notice',
        },
    },

    methods: {
        onClickDetailPage(id) {
            this.$router.push(`/CustomerCenter/${this.detailPath}/Detail/${id}`)
            console.log('id=', id)
        },
    },
}
